import { Api } from '@/core/api.js'
const api = new Api()

// initial state
const state = {
  list: [],
  actives: {},
  status_entities: [],
  current_event: {}
}

// getters
const getters = {
  getList: (state, getters, rootState) => id => {
    // console.log("getList");
    if (id) return state.list[id]
    var aEvents = []
    for (var i in state.list) {
      if (state.list[i].visible) aEvents.push(state.list[i])
    }
    return aEvents
  },

  getActives: (state, getters, rootState) => {
    console.log(state, state.actives)
    return state.actives
  },

  get_by_url: (state, getters, rootState) => url => {
    for (let i in state.list) {
      if (
        (
          state.list[i].name + state.list[i].edition.substring(2)
        ).toLowerCase() === url
      ) { return state.list[i] }
    }
    for (let i in state.actives) {
      if (
        (
          state.actives[i].name + state.actives[i].edition.substring(2)
        ).toLowerCase() === url
      ) { return state.actives[i] }
    }

    return false
  },

  getCurrentEvent: (state, getters, rootState) => () => {
    return state.current_event
  },

  getStatusEntities: (state, getter, rootState) => params => {
    var aStatus = []
    if (typeof params !== 'undefined' && typeof params.entity !== 'undefined') {
      // console.log( params.entity );
      for (var k in state.status_entities) {
        var status = state.status_entities[k]
        if (status.entity === params.entity) {
          aStatus.push(status)
        }
      }
    }

    return aStatus
  },

  getStatusEntityByID: (state, getter, rootState) => id => {
    //   console.log( "getStatusEntityByID - " + id );
    //   console.log( state.status_entities );
    return state.status_entities[id]
  },

  getCategoriesEventSelected: (state, getter, rootState) => () => {
    var aCategories = []
    for (var k in state.current_event.categories) {
      aCategories.push({
        id: state.current_event.categories[k].id,
        name: state.current_event.categories[k].name
      })
    }
    return aCategories
  }
}

// actions
const actions = {
  loadList ({ commit }) {
    // console.log("loadCategories() with type - "+ type);

    var path = 'event'
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data
        for (var i in data) {
          data[i].visible = true
        }

        return commit('setList', data)
      }
    })
  },

  loadActives ({ commit }) {
    // console.log("loadCategories() with type - "+ type);

    var path = 'event/status/1'
    var params = {
      volunteer_visible: 1
    }
    return api.post(path, params).then(function (response) {
      if (response.status) {
        var data = response.data.data
        for (var i in data) {
          data[i].visible = true
        }

        return commit('setEventsActive', data)
      }
    })
  },

  loadByName ({ commit }, eventName) {
    var path = 'event/name/' + eventName
    // console.log( "--- LOAD BY NAME ---" );
    return api.get(path).then(function (response) {
      if (response.status) {
        var data = response.data
        data.visible = true

        return commit('setCurrentEvent', data)
      }
    })
  }
}

// mutations
const mutations = {
  setList (state, data) {
    state.list = data
  },

  addEvent (state, event) {
    var list = { ...state.list }
    list[event.id] = event

    state.list = list
  },

  setCurrentEvent (state, event) {
    state.current_event = event
    var list = { ...state.list }
    list[event.id] = event

    state.list = list
  },

  applyFilters (state, filters) {
    var list = { ...state.list }
    if (!filters) {
      for (var i in list) {
        list[i].visible = true
      }
    } else {
      for (let i in list) {
        list[i].visible = false
      }
      for (let i in list) {
        var item = list[i]
        // console.log( " ---- ITEM " + item.name + " --- " );
        var bFound = true
        for (var k in filters) {
          var itemValue = typeof item[k] === 'object' ? item[k].id : item[k]
          // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
          if (item.hasOwnProperty(k) && filters[k] != itemValue) {
            bFound = false
          }
        }

        list[i].visible = bFound
      }
    }

    state.list = list
  },

  setEventsActive (state, events) {
    state.actives = events
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
